// Import the Firebase core and individual services
import { initializeApp, getApps } from 'firebase/app';
import { getAuth } from 'firebase/auth';
import { getFirestore } from 'firebase/firestore';
import { getStorage, ref } from 'firebase/storage';
import { getPerformance } from 'firebase/performance';
import { getAnalytics } from 'firebase/analytics';
import { getDatabase, ref as dbRef } from 'firebase/database';
import { getRemoteConfig, fetchAndActivate, getValue } from 'firebase/remote-config';
import { initializeAppCheck, ReCaptchaEnterpriseProvider } from 'firebase/app-check';
import { getMessaging, isSupported } from 'firebase/messaging';

import config from './config';

// Initialize Firebase app
const firebaseApp = getApps().length ? getApps()[0] : initializeApp(config.firebase);

// Initialize App Check
if (process.env.NODE_ENV === 'development') {
  window.FIREBASE_APPCHECK_DEBUG_TOKEN = true;
}

const appCheck = initializeAppCheck(firebaseApp, {
  provider: new ReCaptchaEnterpriseProvider(process.env.REACT_APP_APP_CHECK_KEY),
  isTokenAutoRefreshEnabled: true
});

// Initialize individual services
export const auth = getAuth(firebaseApp);
export const database = getDatabase(firebaseApp);
export const databaseRef = dbRef; // Export the ref function for the Realtime Database
export const storage = getStorage(firebaseApp);
export const storageRef = ref;
export const performance = getPerformance(firebaseApp);
/* Initialize Firestore with custom instance (mynortheast-instance) */
export const firestore = getFirestore(process.env.REACT_APP_FIREBASE_FIRESTORE_BUCKET);
export const remoteConfig = getRemoteConfig(firebaseApp);
export const messaging = getMessaging(firebaseApp);
export const messagingRef = {
  isSupported
};

// // Configure Remote Config
// remoteConfig.settings = {
//   fetchTimeoutMillis: 60000,
//   minimumFetchIntervalMillis: 300000
// };

// remoteConfig.defaultConfig = {
//   all_issues: "COVID-19,Sexual Health,Pregnancy,Cold or Flu,Gastrointestinal,Skin,Children's Health,Other\n",
// };

// // Fetch and activate Remote Config values
// export const fetchRemoteConfigValues = async () => {
//   try {
//     await fetchAndActivate(remoteConfig);
//     const mentalHealthInboxValue = getValue(remoteConfig, 'mental_health_inbox').asString();
//     const mentalHealthInbox = JSON.parse(mentalHealthInboxValue);
//     return { mentalHealthInbox };
//   } catch (error) {
//     console.error("Error fetching remote config:", error);
//     return null;
//   }
// };

export default firebaseApp;
